(function () {
  'use strict';

  // Keyword -> icon, checked in order; first match wins.
  var ICON_RULES = [
    { re: /\b(replaces?|all-?in-?one|combine[sd]?)\b/i, icon: 'check-circle' },
    { re: /\b(focus|cognitive|alpha-?gpc|l-?theanine|tyrosine|memory|mental|nervous)\b/i, icon: 'brain' },
    { re: /\b(creatine|strength|power|energy|muscle|recovery|performance)\b/i, icon: 'lightning' },
    { re: /\b(electrolyte|hydration|hydrate|magnesium|potassium|sodium|water)\b/i, icon: 'droplet' }
  ];
  var DEFAULT_ICON = 'check-circle';

  // Mirrors snippets/icon-*.liquid so this can run client-side without a round trip.
  var ICON_SVG = {
    brain: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-brain" viewBox="0 0 24 24"><path d="M9 4a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 2 5.5A3 3 0 0 0 9 20a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3ZM15 4a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3 3 0 0 1-2 5.5A3 3 0 0 1 15 20a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    lightning: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-lightning" viewBox="0 0 24 24"><path d="M8.426 13.006c-.057 0-.057 0-.115-.006-.633-.07-1.095-.698-1.032-1.402l.61-7.445C7.95 3.5 8.445 3 9.037 3H13.5c.128 0 .254.023.375.07.602.23.922.958.715 1.627L13.1 8.802h2.748c.203 0 .402.06.578.173.55.356.738 1.14.418 1.75-.414.816-4.58 7.816-5.926 10.075-.107.18-.381.092-.37-.117L11 13l-2.573.006z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    droplet: '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-droplet" viewBox="0 0 24 24"><path d="M20 14c0-4.418-8-12-8-12S4 9.582 4 14a8 8 0 1 0 16 0z" stroke="#000"/></svg>',
    'check-circle': '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-check-circle" viewBox="0 0 24 24"><path d="m7 12.5 3 3 7-7" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  // "Focus: Alpha-GPC, ..." -> label "Focus", detail "Alpha-GPC, ...".
  // Bullets with no delimiter render icon + single line (no bold label).
  var LABEL_SPLIT = /^([^:—]{1,40})[:—]\s*(.+)$/s;

  // Some metafields don't use a real bulleted list -- the merchant typed a
  // literal bullet character at the start of each line instead.
  var LEADING_BULLET = /^[•\-*·]\s*/;

  function pickIcon(text) {
    for (var i = 0; i < ICON_RULES.length; i++) {
      if (ICON_RULES[i].re.test(text)) return ICON_RULES[i].icon;
    }
    return DEFAULT_ICON;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function rowHtml(rawText) {
    var text = rawText.replace(LEADING_BULLET, '').trim();
    if (!text) return null;

    var label = null;
    var detail = text;
    var match = LABEL_SPLIT.exec(text);
    if (match) {
      label = match[1].trim();
      detail = match[2].trim();
    }

    var icon = pickIcon(label || detail);
    var safeLabel = label ? escapeHtml(label) : null;
    var safeDetail = escapeHtml(detail);

    return (
      '<span class="icon-list-row__icon">' + ICON_SVG[icon] + '</span>' +
      '<span class="icon-list-row__copy' + (safeLabel ? ' has-label' : '') + '">' +
      (safeLabel ? '<strong class="icon-list-row__label">' + safeLabel + '</strong>' : '') +
      '<span class="icon-list-row__detail">' + safeDetail + '</span>' +
      '</span>'
    );
  }

  function buildRow(li) {
    var html = rowHtml(li.textContent);
    if (!html) return;
    li.className = 'icon-list-row';
    li.innerHTML = html;
  }

  // Container already has real <li> bullets -- the common case.
  function processListItems(container) {
    var items = container.querySelectorAll('li');
    if (!items.length) return false;
    for (var i = 0; i < items.length; i++) {
      // Already-built rows (e.g. hardcoded in-theme markup) are left
      // alone -- only raw metafield-driven <li>s get transformed.
      if (items[i].classList.contains('icon-list-row')) continue;
      buildRow(items[i]);
    }
    return true;
  }

  // No <li> anywhere -- bullets are plain text lines (separate <p> tags,
  // <br>-separated, or one block of text). A line with a leading bullet
  // character becomes a row; any line(s) before the first bullet are a
  // label/heading ("Benefits:"), not a bullet, so they're kept as a
  // heading instead of being turned into a bogus icon row.
  function processPlainText(container) {
    var raw = container.innerText || container.textContent || '';
    var lines = raw
      .split(/\n+/)
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);

    var heading = '';
    var bulletLines = [];
    for (var i = 0; i < lines.length; i++) {
      if (LEADING_BULLET.test(lines[i])) {
        bulletLines.push(lines[i]);
      } else if (!bulletLines.length) {
        heading = heading ? heading + ' ' + lines[i] : lines[i];
      }
    }
    if (bulletLines.length < 2) return; // not bullet-shaped content -- leave it alone

    var frag = document.createDocumentFragment();
    if (heading) {
      var h = document.createElement('p');
      h.className = 'icon-list-heading';
      h.textContent = heading.replace(/:\s*$/, '');
      frag.appendChild(h);
    }

    var ul = document.createElement('ul');
    for (var j = 0; j < bulletLines.length; j++) {
      var html = rowHtml(bulletLines[j]);
      if (!html) continue;
      var li = document.createElement('li');
      li.className = 'icon-list-row';
      li.innerHTML = html;
      ul.appendChild(li);
    }
    if (!ul.children.length) return;

    frag.appendChild(ul);
    container.innerHTML = '';
    container.appendChild(frag);
  }

  function animateIn(container) {
    var rows = container.querySelectorAll('.icon-list-row');
    if (!rows.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      container.classList.add('is-visible');
      return;
    }

    for (var i = 0; i < rows.length; i++) {
      rows[i].style.setProperty('--il-delay', i * 70 + 'ms');
    }

    if (!('IntersectionObserver' in window)) {
      container.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            container.classList.add('is-visible');
            io.unobserve(container);
          }
        }
      },
      { threshold: 0.2 }
    );
    io.observe(container);
  }

  function processContainer(container) {
    var usedRealList = processListItems(container);
    if (!usedRealList) processPlainText(container);
    animateIn(container);
  }

  function init() {
    var containers = document.querySelectorAll('[data-icon-list]');
    for (var i = 0; i < containers.length; i++) processContainer(containers[i]);
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
